import { pluralizeIso8601Period } from 'shared/lib';

import type { TCreditFormCommonFields, TCreditPurposeFormFields } from 'entities/creditForm';

export const getCreditPurposeStepLabel = (
  formFields: TCreditFormCommonFields,
  formFieldsLabels: Partial<Record<keyof TCreditFormCommonFields, string>>,
  stepFields: Array<keyof TCreditPurposeFormFields>,
) =>
  stepFields.map((key) => {
    switch (key) {
      case 'period': {
        return {
          fieldLabel: String(formFieldsLabels[key]),
          fieldValue: pluralizeIso8601Period(formFields[key]?.value || ''),
        };
      }
      case 'purpose': {
        return {
          fieldLabel: String(formFieldsLabels[key]),
          fieldValue: String(formFields[key]?.label),
        };
      }
      default: {
        return {
          fieldLabel: String(formFieldsLabels[key]),
          fieldValue: String(formFields[key]),
        };
      }
    }
  });
